<template>
  <v-card class="ma-5" style="margin-bottom: 40px !important;">
    <v-img class="white--text align-end" :src="post.imageLink['720']" />
    <v-card-title class="posttitle">{{ post.title }}</v-card-title>
    <v-card-actions>
      <v-card-subtitle>{{ rank+1 }}. Platz, {{ post.votes }} Stimmen</v-card-subtitle>
      <v-spacer></v-spacer>
      <v-btn icon @click="show = !show" >
        <v-icon>{{ show ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
      </v-btn>
    </v-card-actions>
    <v-expand-transition>
      <div v-show="show">
        <v-divider></v-divider>
        <v-card-subtitle v-if="post.showName" class="pb-0">von {{ post.user }}</v-card-subtitle>
        <v-card-subtitle v-else class="pb-0">von Unbekannt</v-card-subtitle>
        <v-card-text class="text--primary">
          <div class="primary--text">{{ post.location }}</div>
        </v-card-text>
        <v-card-text>
          {{ post.description }}
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
export default {
  name: 'Card',
  props: ['post', 'rank'],
  data () {
    return {
      show: false
    }
  },
  computed: {
    disabled () {
      return this.voted || this.$store.getters.votes === 3
    },
    buttontext () {
      return this.voted ? 'Abgestimmt' : 'Abstimmen'
    }
  },
  methods: {
    vote (id) {
      this.$store.commit('incrementVotes')
      this.$store.dispatch('addVote', { id: id })
      if (this.$store.getters.votes === 3) {
        this.$store.commit('toggleSnackbar')
      }
      this.voted = true
      this.$cookies.set('zuversicht', this.$store.getters.votes)
    }
  }
}
</script>
